// src/components/Report/shared/ScoreRing.jsx
import React from "react";
import { motion } from "framer-motion";
import { hex2rgba } from "./reportUtils";

export default function ScoreRing({ score, color, size = 64, strokeWidth = 7 }) {
  const numericScore = score === "" || score == null ? 0 : score;
  const r = (size - strokeWidth * 2) / 2;
  const circ = 2 * Math.PI * r;
  const dash = (numericScore / 100) * circ;

  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
      <circle
        cx={size / 2} cy={size / 2} r={r} fill="none"
        stroke={hex2rgba(color, 0.15)} strokeWidth={strokeWidth}
      />
      <motion.circle
        cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color}
        strokeWidth={strokeWidth} strokeLinecap="round" strokeDasharray={circ}
        initial={{ strokeDashoffset: circ }}
        animate={{ strokeDashoffset: circ - dash }}
        transition={{ duration: 1.1, ease: "easeOut", delay: 0.1 }}
      />
      <text
        x={size / 2} y={size / 2 + 1} textAnchor="middle" dominantBaseline="middle"
        fill="#1e293b" fontSize={size > 56 ? 13 : 10} fontWeight={700}
        style={{
          transform: "rotate(90deg)",
          transformOrigin: `${size / 2}px ${size / 2}px`,
          fontFamily: "'DM Sans',sans-serif",
        }}
      >
        {score}%
      </text>
    </svg>
  );
}